var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img_box"},[_c('img',{staticClass:"bg_img",attrs:{"src":_vm.url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }